module.exports = __webpack_public_path__ + "static/media/material-ui.e4efb86c.svg";